module.exports = __webpack_public_path__ + "img/banner.0a2f0dc6.png";